var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#128abc;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M195.806,116.161h35.956v120.653H60.435c-19.993,0-36.196-13.503-36.196-30.163c0-16.659,16.203-30.162,36.196-30.162 c12.032-0.001,22.697,4.892,29.275,12.421V99.626c-6.578-7.529-17.243-12.423-29.275-12.421 c-19.993,0-36.196,13.505-36.196,30.163v87.153"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 90.858,
    y1: 116.161,
    x2: 136.959,
    y2: 116.161
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M212.635,66.033c0,25.873-46.85,104.771-46.85,104.771s-46.85-78.898-46.85-104.771c0-25.873,20.975-46.846,46.85-46.846 C191.66,19.186,212.635,40.16,212.635,66.033z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M185.792,66.033c0,11.048-8.954,20.016-20.007,20.016c-11.05,0-20.003-8.968-20.003-20.016c0-11.048,8.953-20.007,20.003-20.007 C176.838,46.026,185.792,54.985,185.792,66.033z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.3d98db4c5f2e1c8bace4ce63a3d0dc46.svg";
export { ForwardRef as ReactComponent };